<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <h2>Contact</h2>
    <div class="contact-infos" v-if="contact">
      <p><strong>Représentant</strong></p>
      <p>{{ ['M.', 'M.', 'Mme', 'Mlle', 'MM.'][contact.Civility] }} {{ contact.FirstName }} {{ contact.LastName }}</p>
      <p>{{ contact.TypeLabel }}</p>
      <p><a :href="`mailto:${contact.Email}`"><em>{{ contact.Email }}</em></a></p>
      <p>{{ contact.PortablePhoneNumber }}</p>
    </div>
    <div v-else>
      <strong>Aucun représentant</strong>
    </div>
    <p class="mt-1">
      <a class="d-block" :href="getIntraRedirectUrl('~/Pages/Fournisseur/MesContacts.aspx')" target="_blank" rel="noreferrer">
        <button class="btn-cmem w-100">Liste des contacts</button>
      </a>
    </p>
  </div>


</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getContactFrs} from "@/utils/dashboardCdm";
import {getIntraRedirectUrl} from "@/helpers/getRedirectUrlHelper";

export default {
  components: {TileLoader},
  name: 'FrsContactTile',
  props: ["frsGuid"],
  data() {
    return {
      loading: 0,
      contact: null
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    frsGuid() {
      this.initData();
    }
  },
  methods: {
    getIntraRedirectUrl,
    initData() {
      if (!this.frsGuid) return;

      this.loading = 1;
      getContactFrs(this.frsGuid).then(res => {
        if (res.length)
          this.contact = res[0];
        this.loading = 0;
      })
    }
  },
  computed: {}
}
</script>

<style scoped>
.white-box {
  flex-basis: fit-content;
  padding: 12px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

p {
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FrsContactTile.vue